<template>
  <md-button class="md-primary submit-btn" @click="readinessCheck()" :disabled="this.disabled">
    Readiness Check
  </md-button>
</template>

<script>
import { mapGetters } from "vuex";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import filters from "@/components/utils/filters";
import { schema } from "../../validators/base"
import { schema as greenLightSchema } from "../../validators/greenLight";

export default {
  components: {
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    // standard list of options from store
    ...mapGetters([
      "uploadedDocuments",
      "user",
    ]),
  },
  mounted() {
  },
  methods: {
    ...filters,
    async getDocuments() {
      await this.$store.dispatch('fetch_doc_uploaded', { application_id: this.application.loan.id, showDeleted: false });
    },
    async readinessCheck() {
      let returnValue = {
        hasError: false,
        errors: [],
        message: ""
      }
      this.$modal.show(WaitingDialog, {
        title: "Validating Application...",
        message: "Please wait while we are validating the application.",
      });
      try {
        if (!this.uploadedDocuments) {
          await this.getDocuments();
        }
        console.log("uploadedDocuments", this.uploadedDocuments);
        returnValue = this.validateLender(returnValue);
        if (!returnValue.hasError) {
          const status = await this.$store.dispatch("submit_for_application_readinessCheck", this.application);
          if (status && status.success === false) {
            returnValue.hasError = true;
            returnValue.errors = status.data;
            returnValue.message = this.handleError(status);
          }
        }

        if (this.$modal.submit) {
          this.$modal.submit();
        }

      } catch (e) {
        if (this.$modal.submit) {
          this.$modal.submit();
        }
        returnValue.hasError = true;
        returnValue.errors = e.response ? e.response : e.message;
        returnValue.message = e.response ? e.response.data : e.message;
      }

      this.$emit("onComplete", returnValue);
    },

    validateLender(returnValue) {
      let validation = {};
      let documentCheck = [];
      switch (this.application.loan.submission.current.product.lender_name) {
        case "Greenlight Auto":
          documentCheck = this.greenLightDocumentCheck();
          validation = greenLightSchema.application.validate(this.application, { abortEarly: false, allowUnknown: true });
          break;
        default:
          validation = schema.application.validate(this.application, { abortEarly: false, allowUnknown: true });
      }

      if (validation.error && validation.error.details.length) {
        let errorMessage = '<ul>';
        validation.error.details.forEach(detail => {
          errorMessage = errorMessage + `<li>${detail.message.replace(/\./g, ' => ').replace(/\_/g, ' ')}</li>`;
        })
        errorMessage = errorMessage + '</ul>'
        returnValue.hasError = true;
        returnValue.errors = validation.error.details;
        returnValue.message = errorMessage;
      }

      if(documentCheck.length) {
        let errorMessage = '<ul>';
        returnValue.hasError = true;
        returnValue.errors = [...returnValue.errors,...documentCheck];
        documentCheck.forEach(detail => {
          errorMessage = errorMessage + `<li>${detail.replace(/\./g, ' => ').replace(/\_/g, ' ')}</li>`;
        })
        errorMessage = errorMessage + '</ul>'
        returnValue.message = returnValue.message + errorMessage;
      }
      return returnValue;
    },

    greenLightDocumentCheck () {
      const documentsError = [];

      if ((!this.uploadedDocuments.includes("Drivers licence back") && !this.uploadedDocuments.includes("1 - Drivers licence back")) ||
      (!this.uploadedDocuments.includes("Drivers licence front") && !this.uploadedDocuments.includes("1 - Drivers licence front"))
      ){
        documentsError.push("The documents Drivers licence is required")
      }

      if (!this.uploadedDocuments.includes("Bank/MyGov Statement") &&
      !this.uploadedDocuments.includes("2 - 3 Months Bank Statements (Link)") &&
            !this.uploadedDocuments.includes("2 - 6 Months Bank Statements (Link)")) {
            documentsError.push("The documents bank statement is required")
      }

      if (!this.uploadedDocuments.includes("Privacy Consent") &&
          !this.uploadedDocuments.includes("Privacy Consent Online")){
          documentsError.push("The documents privacy consent is required")
        }
        if (this.application.applicants.length > 1) {
          if (!this.uploadedDocuments.includes("Applicant 2 Payslip")) {
              documentsError.push("The documents Applicant 2 Payslip is required")
          }
        }

        if (!this.uploadedDocuments.includes("Recent Payslip 1") &&
            !this.uploadedDocuments.includes("3 - Recent Payslip 1") &&
            !this.uploadedDocuments.includes("3 - Recent Payslip 2") &&
            !this.uploadedDocuments.includes("Recent Payslip 2")) {
            documentsError.push("The documents payslip is required")
        }
        return documentsError;
    },

    handleError(status) {
      let errorMessage = '';
      if (status.data) {
        let errorData = JSON.parse(status.data);
        if (Array.isArray(errorData)) {
          Object.values(errorData).forEach((element) => {
            let path_hint = element.field;
            if (path_hint != undefined) {
              let fieldArr = path_hint.split(".");
              let field = filters.capitalize(fieldArr[fieldArr.length - 1]);
              errorMessage += `<p>${field} ${(element.message.toLowerCase().trim())}</p>`;
            } else {
              errorMessage += `<p>${(element.message)}</p>`;
            }
          });
        } else {
          let path_hint = errorData.field;
          if (path_hint != undefined) {
            let fieldArr = path_hint.split(".");
            let field = filters.capitalize(fieldArr[fieldArr.length - 1]);
            errorMessage += `<p>${field} ${(errorData.message.toLowerCase().trim())}</p>`;
          } else {
            errorMessage += `<p>${(errorData.message)}</p>`;
          }
        }
      }

      if (errorMessage === '') {
        errorMessage = JSON.stringify(status);
      }
      return errorMessage;
    }
  },

  created() {
  },
};
</script>
